import { Button, Checkbox, DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPortalDefinitions extends Layout {
    cbCopyToCB: Checkbox;
    labelF: Label;
    labelPFieldsDefinitions: Label;
    labelS: Label;
    labelSDefinitions: Label;
    lblActions: Label;
    lblflds: Label;
    pbAddFieldDef: Button;
    pbAddPortalField: Button;
    pbAddsqld: Button;
    pbAddsqlh: Button;
    pbDelFieldDef: Button;
    pbDelPortalField: Button;
    pbDelsqld: Button;
    pbDelsqlh: Button;
    pbDownPortalField: Button;
    pbEditFieldDef: Button;
    pbEditsqld: Button;
    pbEditsqlh: Button;
    pbSearchFieldDef: Button;
    pbSearchsqld: Button;
    pbSearchsqlh: Button;
    pbUpPortalField: Button;
    pnlActions: Panel;
    pnlflds: Panel;
    pnlpflds: Panel;
    pnlsqls: Panel;
    sourceRenditionLogixProfiles: DataSource;
    sourceRenlgxflds: DataSource;
    sourceRenlgxpflds2: DataSource;
    sourceRenlgxpflds: DataSource;
    sourceRenlgxsqld2: DataSource;
    sourceRenlgxsqld: DataSource;
    sourceRenlgxsqlh2: DataSource;
    sourceRenlgxsqlh: DataSource;
    tblflds: Table;
    tblpflds: Table;
    tblsqld: Table;
    tblsqlh: Table;
    textboxLgxpId: Textbox;
}
